import { CalendarCheck, ShieldCheck, Sparkles, SearchCheck, Heart } from "lucide-react";

const TIMELINE_STEPS = [
  {
    icon: CalendarCheck,
    title: "1. Book Online",
    description: "Choose your service, customize your plan, and pick a date in under 60 seconds.",
  },
  {
    icon: ShieldCheck,
    title: "2. Prepare Your Home",
    description: "Secure your valuables, contain pets, and provide clear access instructions.",
  },
  {
    icon: Sparkles,
    title: "3. The Clean",
    description: "Our vetted, professional team arrives fully equipped to transform your space.",
  },
  {
    icon: SearchCheck,
    title: "4. Quality Check",
    description: "We review our work to ensure it meets the rigorous Uplevel Standard.",
  },
  {
    icon: Heart,
    title: "5. Relax & Enjoy",
    description: "Come home to a spotless space, backed by our 200% Satisfaction Guarantee.",
  }
];

export const WhatToExpectTimeline = () => {
  return (
    <section className="py-16 bg-background">
      <div className="container px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight mb-4">What to Expect</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            From booking to relaxing in your spotless home, here is how the Uplevel Cleaning experience works.
          </p>
        </div>
        
        <div className="relative border-l-2 border-primary/20 ml-4 md:ml-8 space-y-8 pb-4">
          {TIMELINE_STEPS.map((step, index) => (
            <div key={index} className="relative pl-8 md:pl-12 anim-fade-up is-visible" style={{ transitionDelay: `${index * 100}ms` }}>
              <div className="absolute -left-[17px] top-1 bg-background border-2 border-primary rounded-full p-1.5 shadow-sm">
                <step.icon className="w-4 h-4 text-primary" />
              </div>
              <div className="bg-card border border-border shadow-sm rounded-xl p-5 hover:border-primary/30 transition-colors">
                <h3 className="font-bold text-lg mb-1">{step.title}</h3>
                <p className="text-muted-foreground text-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
